export enum CommentSort {
  asc = "asc",
  desc = "desc"
}
